import React, { useState } from 'react';
import Translate from '../Translate/Translate';
import LocalizedLink from '../LocalizedLink';
import TopProducts from '../Home/TopProducts/TopProducts';
import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

const GET_CATEGORIES = gql`
  query CategoriesMain {
    categoriesMain {
      id
      title
      slug
    }
  }
`;

type MainCategoryItem = {
  id: string;
  title: string;
  slug: string;
};

type Props = {
  titleKeyword?: string;
  buttonLink?: string;
  buttonKeyword?: string;
};

export default function ErrorPage({
  titleKeyword,
  buttonLink,
  buttonKeyword,
}: Props) {
  const [category, setCategory] = useState('naised');
  const [hasAnyTopProducts, setHasAnyTopProducts] = useState(true);

  const { data, loading } = useQuery<{
    categoriesMain: MainCategoryItem[];
  }>(GET_CATEGORIES);

  const categoryChange = (slug: string) => {
    setCategory(slug);
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const categories = data?.categoriesMain;

  let options;
  if (!loading && categories) {
    options = categories.map((option, index) => {
      const isActive = category === option.slug;

      return (
        <div
          key={index}
          onClick={() => categoryChange(option.slug)}
          className={`flex flex-nowrap snap-center cursor-pointer after:content-['_/_'] last:after:content-[''] after:mx-2 md:after:mx-6 after:text-3xl md:after:text-4xl after:text-rgrey ${
            isActive ? 'text-black' : 'text-rgrey'
          }`}
        >
          <h2 className="text-3xl lg:text-4xl font-axi-bold leading-10">
            {option.title}
          </h2>
        </div>
      );
    });
  }

  return (
    <div className="relative">
      <div className="flex flex-col items-center pt-10 md:pt-16 lg:pt-25">
        {titleKeyword === 'false' ? null : (
          <h3 className="font-axi-bold text-3xl leading-10 max-w-200 text-center lg:text-5xl lg:leading-15 p-5">
            <Translate
              component="errorBanner"
              keyword={titleKeyword ? titleKeyword : 'default'}
            />
          </h3>
        )}
        <LocalizedLink
          className="font-axi-bold bg-rgreen border rounded inline-flex text-white flex-[0_0_100%] justify-center sm:flex-[0_0_auto] m-2.5 px-3.75 py-4 border-solid border-rgreen hover:text-black hover:bg-white hover:transition-all hover:duration-100 hover:border hover:border-solid hover:border-rgrey-light"
          to={buttonLink ? buttonLink : '/'}
          onClick={scrollToTop}
        >
          <Translate
            component="link"
            keyword={buttonKeyword ? buttonKeyword : 'back-home'}
          />
        </LocalizedLink>
        <div className="mt-24 lg:mt-36 xl:mt-44 w-full max-w-full overflow-hidden">
          {hasAnyTopProducts && (
            <div className="flex overflow-x-auto overflow-y-hidden! pb-1 sm:pb-0 scrollbar scrollbar-h-0.5 scrollbar-thumb-rgrey scrollbar-track-rgrey-lightlight scrollbar-thumb-rounded-xs scrollbar-track-rounded-xs mb-12">
              {options}
            </div>
          )}
          <TopProducts
            category={category}
            hasTopProducts={setHasAnyTopProducts}
          />
        </div>
      </div>
    </div>
  );
}
